"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT = void 0;
const types_1 = require("../actions/types");
exports.DEFAULT = {
    searchTerm: '',
    openAttributes: {},
    openCategories: {},
    openTaxonomyClasses: false,
};
exports.default = (state = exports.DEFAULT, action) => {
    switch (action.type) {
        case types_1.FACET_NAVIGATION_SET_SEARCH_TERM:
            return facetNavigationSetSearchTerm(state, action.payload);
        case types_1.FACET_NAVIGATION_SET_OPEN_CATEGORIES:
            return facetNavigationSetOpenCategories(state, action.payload);
        case types_1.FACET_NAVIGATION_SET_OPEN_ATTRIBUTES:
            return facetNavigationSetOpenAttributes(state, action.payload);
        case types_1.FACET_NAVIGATION_SET_OPEN_TAXONOMY_CLASSES:
            return facetNavigationSetOpenTaxonomyClasses(state, action.payload);
        default:
            return state;
    }
};
const facetNavigationSetSearchTerm = (state, searchTerm) => (Object.assign(Object.assign({}, state), { searchTerm }));
const facetNavigationSetOpenCategories = (state, openCategories) => (Object.assign(Object.assign({}, state), { openCategories }));
const facetNavigationSetOpenAttributes = (state, openAttributes) => (Object.assign(Object.assign({}, state), { openAttributes }));
const facetNavigationSetOpenTaxonomyClasses = (state, openTaxonomyClasses) => (Object.assign(Object.assign({}, state), { openTaxonomyClasses }));
